import { currencyLabels } from "@/utils/ranges.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineBanknotes } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import EarningRangeBadge from "@/components/molecules/table/search/badges/EarningRangeBadge";
import LastYearUpdatedBadge from "@/components/molecules/table/search/badges/LastYearUpdatedBadge";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const earningsRangeColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => {
      const from = row.finances?.earnings?.range?.from || null;
      const to = row.finances?.earnings?.range?.to || null;

      return currencyLabels(from, to);
    },
    id: searchColumns(t).earnings_range.id,
    header: () => searchColumns(t).earnings_range.name,
    cell: ({ row }) => {
      const from = row.original.finances?.earnings?.range?.from || null;
      const to = row.original.finances?.earnings?.range?.to || null;

      return (
        <div className={"flex gap-2"}>
          <EarningRangeBadge from={from} to={to} />
          <LastYearUpdatedBadge year={row.original.finances?.earnings?.year || null} />
        </div>
      );
    },
    size: 220,
    meta: {
      heading: {
        icon: HiOutlineBanknotes,
      },
    },
  });

export default earningsRangeColumn;
